var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    height: 18,
    viewBox: "0 96 960 960",
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 936V381h165V216h390v330h165v390H533V771H427v165H120Zm60-60h105V771H180v105Zm0-165h105V606H180v105Zm0-165h105V441H180v105Zm165 165h105V606H345v105Zm0-165h105V441H345v105Zm0-165h105V276H345v105Zm165 330h105V606H510v105Zm0-165h105V441H510v105Zm0-165h105V276H510v105Zm165 495h105V771H675v105Zm0-165h105V606H675v105Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/BuildingIcon.b138d3c7.svg";
export { ForwardRef as ReactComponent };